import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import { BpkListItem } from '@skyscanner-internal/backpack-web/bpk-component-list';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text/src/BpkText';

import type { Strings } from '../FooterFlags';

import STYLES from './FooterFlagLink.module.scss';

export type FooterFlagLinkProps = {
  linkLabel: Strings['selectedOptionLabel'];
  market: string;
  url: string;
};

const FooterFlagLink = ({ linkLabel, market, url }: FooterFlagLinkProps) => (
  <BpkListItem className={STYLES.item}>
    <img
      src={`https://images.skyscnr.com/images/country/flag/small/${market.toLowerCase()}.png`}
      height={11}
      alt=""
      loading="lazy"
    />
    <BpkLink className={STYLES.link} href={url} implicit>
      <BpkText textStyle={TEXT_STYLES.sm}>{linkLabel}</BpkText>
    </BpkLink>
  </BpkListItem>
);
export default FooterFlagLink;
